import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import {
  supportedLngs,
  localeNames,
  localeFlags,
  type Locale,
} from '@/lib/i18n/config';

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { locale } = useParams<{ locale: string }>();

  const currentLang = (locale || i18n.language) as Locale;
  const currentFlag = localeFlags[currentLang] || '🌐';
  const currentName = localeNames[currentLang] || currentLang.toUpperCase();

  const changeLanguage = async (newLang: Locale) => {
    // Changer la langue dans i18next (sauvegarde automatique dans localStorage)
    await i18n.changeLanguage(newLang);

    // Remplacer la locale dans le path
    const pathWithoutLocale = location.pathname.replace(`/${currentLang}`, '');
    const newPath = `/${newLang}${pathWithoutLocale || ''}`;
    navigate(newPath);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm">
          <span className="mr-2">{currentFlag}</span>
          <span className="hidden sm:inline">{currentName}</span>
          <span className="sm:hidden">{currentLang.toUpperCase()}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {supportedLngs.map((lang) => (
          <DropdownMenuItem
            key={lang}
            onClick={() => changeLanguage(lang)}
            className={`cursor-pointer ${
              lang === currentLang ? 'bg-accent' : ''
            }`}
          >
            <span className="mr-2">{localeFlags[lang]}</span>
            {localeNames[lang]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
